/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseHeaderBlockActionType } from './DatabaseHeaderBlockActionType';
import {
    DatabaseHeaderBlockActionTypeFromJSON,
    DatabaseHeaderBlockActionTypeFromJSONTyped,
    DatabaseHeaderBlockActionTypeToJSON,
} from './DatabaseHeaderBlockActionType';
import type { DatabaseTextHeaderBlock } from './DatabaseTextHeaderBlock';
import {
    DatabaseTextHeaderBlockFromJSON,
    DatabaseTextHeaderBlockFromJSONTyped,
    DatabaseTextHeaderBlockToJSON,
} from './DatabaseTextHeaderBlock';

/**
 * 
 * @export
 * @interface DatabaseDescriptionHeaderBlock
 */
export interface DatabaseDescriptionHeaderBlock extends DatabaseTextHeaderBlock {
}

/**
 * Check if a given object implements the DatabaseDescriptionHeaderBlock interface.
 */
export function instanceOfDatabaseDescriptionHeaderBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseDescriptionHeaderBlockFromJSON(json: any): DatabaseDescriptionHeaderBlock {
    return DatabaseDescriptionHeaderBlockFromJSONTyped(json, false);
}

export function DatabaseDescriptionHeaderBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseDescriptionHeaderBlock {
    return json;
}

export function DatabaseDescriptionHeaderBlockToJSON(value?: DatabaseDescriptionHeaderBlock | null): any {
    return value;
}

